import { Tag } from "./Tag";

export class Twitter extends Tag {
    public getTagName(): string {
        return "twitter";
    }
}
